import React from 'react';
import './events.css'
import Nav
 from '../components/layout/nav';
import Search from '../components/common/search';
import EventsTable from '../components/common/eventstable';
 
const Events = () => {
    return ( <>
    <div className='dashboard'>

            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
                <div className='pagecenter'>

                    <div className='homecontainer'>

                        <section>
                            <div className='titlediv2'>
                                     <div className='titlediv'>
                                            <h1>Events Management</h1>
                                            <h2>Manage runway shows and events</h2>
                                        </div>
                                        
                            </div>
                           <Search 
                           search='Search events....'/>
                        <EventsTable />
                               

                           
                        </section>
                            
                    </div>
                        
                </div>
                
               
            </div>

        </div>
    </> );
}
 
export default Events;